import {useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch, faX} from "@fortawesome/free-solid-svg-icons";
import {Empty, Spin} from "antd";
import HelperGeneral from "../../helpers/HelperGeneral";
import Api from "../../services/Api";
import {useWindowWidth} from "../helpers/useWindowWidth";

const Search = (props) => {
    const [productSearchLoading, setProductSearchLoading] = useState(false);
    const [product, setProduct] = useState([]);
    const [productSearchShow, setProductSearchShow] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [addOrder, setAddOrder] = useState(false);

    let windowWidth = useWindowWidth();
    let timer = null;

    // useEffect(() => {
    //     if (typeof props.addOrder !== "undefined") {
    //         setAddOrder(true);
    //     }
    // }, []);

    const searchEvent = (event) => {
        event.preventDefault();
        const keyword = event.target.value;
        setKeyword(keyword);
        setProductSearchShow(true);
        clearTimeout(timer);
        let ms = 150;
        timer = setTimeout(() => {
            if (keyword?.length > 0) {
                setProductSearchLoading(true);
                Api.productSearch(keyword).then((e) => {
                    if (e?.data?.data) {
                        setProduct(e.data?.data);
                    } else {
                        setProduct([])
                    }
                    setProductSearchLoading(false);
                }).catch((e) => {
                    HelperGeneral.alert(e);
                    setProductSearchLoading(false);
                });
            }
        }, ms);
    };

    return (
        <div className={"search"}>
            <input
                type={"text"}
                className={"input"}
                style={{border: "none", width: windowWidth > 991 ? "240px" : "200px"}}
                placeholder={"Ürün ara"}
                onKeyUp={(e) => {
                    if (e?.target?.value.length >= 3) {
                        searchEvent(e);
                    } else {
                        setProduct([]);
                    }
                }}
                onBlur={(event) => {
                    setTimeout(() => {
                        setProductSearchShow(false);
                        event.target.value = "";
                        setProduct([])
                        setKeyword("")
                    }, 300);
                }}
                onFocus={() => setProductSearchShow(true)}
            />
            <div className={"button"}>
                {
                    keyword?.length ? (
                        <FontAwesomeIcon
                            icon={faX}
                            className={"icon"}
                            onClick={() => {
                                setProduct([])
                                setKeyword("")
                            }}
                        />
                    ) : (
                        <FontAwesomeIcon icon={faSearch} className={"icon"}/>
                    )
                }
            </div>
            <div className={"lists " + (productSearchShow ? "show" : "")}>
                <Spin spinning={productSearchLoading}>
                    {
                        product && (
                            product?.map((v, i) => (
                                    <div onClick={() => {
                                        // if (addOrder) {
                                        //     props.addOrderItem({
                                        //         id: v.id,
                                        //         product: {
                                        //             imageUrl: v.largeImageUrl
                                        //                 ? v.largeImageUrl
                                        //                 : require("../../assets/images/png/default-product.png"),
                                        //             productId: v.id,
                                        //             productName: v.name,
                                        //         },
                                        //         quantity: 1,
                                        //     });
                                        // } else {
                                        //     HelperGeneral.pageChange(props, "/product/" + v.id);
                                        // }
                                        HelperGeneral.pageChange(props, "/product/" + v.id);
                                    }} key={i}>
                                        <span className={"img"}>
                                            <img
                                                src={v?.images[0].w100x100 ?? require("../../assets/images/png/default-product.png")}
                                                alt={v?.name}
                                                className={"rounded"}
                                            />
                                        </span>
                                        <span className={"name"}>{v?.name} </span>
                                    </div>
                                )
                            )
                        )
                    }
                    {
                        productSearchLoading && product?.length < 1 && (
                            <span className={"p-3 d-block"}/>
                        )
                    }
                    {
                        product?.length < 1 && !productSearchLoading && (
                            <Empty description={keyword?.length && product ? "Aradığınız kriterlere göre ürün bulunamadı" : "Ürün bilgisi giriniz"}/>
                        )
                    }
                </Spin>
            </div>
        </div>
    );
};

export default withRouter(Search);
